import React from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";

const UserBanking = () => {
  return (
    <div className="fixed_width">
      <div>
        <AdminHeader />
        <AdminNavbar />
        <div className="restore  mt-3  items-center  flex justify-center flex-col  ">
          <div className="restore_indisde_heading rounded-md w-[90%] bg-gradient-to-t from-blue-900 to-blue-950">
            <p className="text-white  ml-2 font-bold p-1"> User Bankings</p>
            <div className="userdatatable mt-3 bg-white   justify-center flex">
              <div className="  bg-[#fff]  px-[10px] py-[20px] items-center flex-col flex w-[100%] justify-between">
                <div className="flex justify-between w-[90%] items-center">
                  <div className="flex w-[200px] justify-around">
                    <p className="">show</p>
                    <select
                      name=""
                      id=""
                      className="border border-solid border-gray-300"
                    >
                      <option value="">1</option>
                      <option value="">2</option>
                      <option value="">3</option>
                    </select>
                    <polygon>entries</polygon>
                  </div>
                  <div className="searchh">
                    <label htmlFor="" className="">
                      search
                    </label>
                    <input type="search" />
                  </div>
                </div>
                <div className="flex w-[90%] mt-2 flex-col">
                  <div className="overflow-x-auto">
                    <div className="p-1.5 w-full  inline-block align-middle">
                      <div className="overflow-hidden border shadow-md mb-4 ">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-300">
                            <tr>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-left text-black font-bold uppercase "
                              >
                                USERNAME
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-left text-black font-bold uppercase "
                              >
                                CREDIT REF
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-left text-black font-bold uppercase "
                              >
                                BALANCE
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                EXPORSURE
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                EXPOSURE LIMIT
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                AVAILABLE BALANCE
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                REF P./L
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                PARTNERSHIP
                              </th>
                              <th
                                scope="col"
                                className="px-6 py-3 text-xs font-bold text-right text-black font-bold uppercase "
                              >
                                SATUS
                              </th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            {/* <tr>
                  <td className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                    1
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                    Jone Doe
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                    jonne62@gmail.com
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                    <a
                      className="text-green-500 hover:text-green-700"
                      href="#"
                    >
                      Edit
                    </a>
                  </td>
                  <td className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap">
                    <a
                      className="text-red-500 hover:text-red-700"
                      href="#"
                    >
                      Delete
                    </a>
                  </td>
               </tr>*/}
                          </tbody>
                        </table>
                        <div className="text-center px-3">no data</div>
                      </div>
                      <div className="flex justify-between">
                        <span className="">Showing 0 to 0 of 0 entries</span>
                        <div className="flex justify-between w-[250px]">
                          <a>first</a>
                          <a> previous</a>
                          <a> Next</a>
                          <a>last</a>
                        </div>
                      </div>
                    </div>

                    <div className="userbank_btn ">
                      <button className="bg-black text-white px-2 py-1 w-[200px] rounded">
                        Clear All
                      </button>
                      <input
                        type="text"
                        className="px-2  ml-6 py-2 w-[200px] border"
                        placeholder="password"
                      />
                      <button className="bg-blue-900 text-white font-fold px-2 py-1 w-[200px] rounded">
                        Submit Payment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserBanking;
